import {useQuery} from '@tanstack/react-query';
import {getAvailableEmails} from '@/api/operations/get-available-emails';

export function useAvailableEmailsQuery() {
  const query = useQuery({
    queryKey: ['availableEmails'],
    async queryFn() {
      const {data} = await getAvailableEmails();
      return data;
    },
  });

  return query;
}
